// Version 1.1.2 2025-09-11
import React, { useState, useEffect } from 'react';
import { fetchDataFromServer } from '../apiUtils';

const asBool = (v) => v === true || v === 'true' || v === 1 || v === '1';

const VendegLap2 = () => {
  const [lampState, setLampState] = useState(false);
  const [autoLampState, setAutoLampState] = useState(false);
  const [remainingTime, setRemainingTime] = useState(null);
  const [heartbeat, setHeartbeat] = useState(0);
  const [relay, setRelay] = useState(null); // <-- kezdetben ismeretlen
  const relayLoaded = relay !== null;

  const fetchLampStates = () => {
    // Blynk lekérések ...
    fetch('https://fra1.blynk.cloud/external/api/get?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v0')
      .then(r => r.text()).then(t => setLampState(t === '1')).catch(() => {});

    fetch('https://fra1.blynk.cloud/external/api/get?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v5')
      .then(r => r.text()).then(t => setAutoLampState(t === '1')).catch(() => {});

    fetch('https://fra1.blynk.cloud/external/api/get?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v6')
      .then(r => r.text()).then(t => setRemainingTime(t)).catch(() => {});

    fetch('https://fra1.blynk.cloud/external/api/get?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v8')
      .then(r => r.text()).then(t => setHeartbeat(parseInt(t))).catch(() => {});

    // API-006 / Relay
    fetchDataFromServer('API-006', 'Relay', 'GET')
      .then(resp => {
        const raw = resp?.Relay?.value ?? resp?.Relay;
        if (raw !== undefined) setRelay(asBool(raw));
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchLampStates();
    const id = setInterval(fetchLampStates, 5000);
    return () => clearInterval(id);
  }, []);

  const handleClearData = () => {
    localStorage.clear();
    alert('A böngésző tárolt adatai törölve lettek.');
  };

  const toggleLamp = () => {
    const next = !lampState;
    setLampState(next);
    fetch(`https://fra1.blynk.cloud/external/api/update?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v0=${next ? 1 : 0}`).catch(() => {});
  };

  const toggleAutoLamp = () => {
    const next = !autoLampState;
    setAutoLampState(next);
    fetch(`https://fra1.blynk.cloud/external/api/update?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v5=${next ? 1 : 0}`).catch(() => {});
  };

  const openGate = () => {
    fetch(`https://fra1.blynk.cloud/external/api/update?token=pEI3Hwp_uLXu00ZCVUFRgjFhFEVbRVUe&v1=1`).catch(() => {});
  };

  // API-006 / Relay toggle
  const toggleRelay = () => {
    if (!relayLoaded) return; // amíg nem ismert az állapot, ne engedjük
    const next = !relay;
    setRelay(next);
    fetchDataFromServer('API-006', 'Relay', 'POST', next ? 'true' : 'false').catch(() => {});
  };

  return (
    <div className="pageContainer">
      <div className="headerRow">
        <button className="clearButton" onClick={handleClearData}>Törlés</button>
        <h2 className="centeredTitle">
          Szabadság utca 
          <h4 style={{ display: 'inline', marginLeft: '5px' }}>X1.1.2</h4>
          <span className={`heartbeat-dot ${heartbeat === 1 ? 'green' : 'red'}`}></span>
        </h2>
      </div>

      <div className="buttonGrid">
        <button className="button">Kiskapu</button>
        <button className="button" onClick={openGate}>Kapu nyitás</button>
      </div>

      <div className="switchRow">
        <label className="toggleContainer">
          Lámpa
          <input type="checkbox" checked={lampState} onChange={toggleLamp} className="customSwitch" />
        </label>
        <label className="toggleContainer">
          Auto_lamp
          <input type="checkbox" checked={autoLampState} onChange={toggleAutoLamp} className="customSwitch" />
        </label>
        <label className="toggleContainer">
          Relay
          <input
            type="checkbox"
            checked={!!relay}
            disabled={!relayLoaded}       // első beolvasásig szürke
            onChange={toggleRelay}
            className="customSwitch"
          />
        </label>
      </div>

      <div className="remainingTimeBox">
        <p>Hátralévő világítási idő: {remainingTime !== null ? `${remainingTime} perc` : 'Betöltés...'}</p>
      </div>
    </div>
  );
};


export default VendegLap2;
